import React from "react";
import {
  FaFacebookF,
  FaTwitter,
  FaInstagram,
  FaLinkedinIn,
  FaGooglePay,
  FaGooglePlay,
} from "react-icons/fa";
import { TbMail } from "react-icons/tb";
import { MdOutlineLocalPhone } from "react-icons/md";
// import { Link } from "react-router-dom";
import { FaWhatsapp } from "react-icons/fa";
import { BiLogoPlayStore } from "react-icons/bi";

const TopNav = () => {
  return (
    <nav className="hidden md:block bg-[#191C1F] text-white px-6 md:px-16 py-2">
      <div className="container mx-auto flex items-center justify-between relative">
        {/* 1st Section - Phone and Email */}
        <div className="flex items-center space-x-4">
          <div className="flex items-center space-x-1">
            <MdOutlineLocalPhone size={22} color="#2D8014" />
            <span className="text-sm tracking-wide">+91 81445 70016</span>
          </div>
          <div className="flex items-center space-x-2">
            <TbMail size={23} color="#2D8014" />
            <span className="text-sm tracking-wide">
              debdebasmitagrandbazar@gmail.com
            </span>
          </div>
        </div>

        {/* 3rd Section - Social Media Icons */}
        <div className="flex space-x-4">
          <a
            href="https://play.google.com/store/apps/details?id=com.seetal"
            className="text-[#2D8014]"
          >
            <BiLogoPlayStore />
          </a>

          <a
            href="https://www.facebook.com/debonlineshopping"
            className="text-[#2D8014]"
          >
            <FaFacebookF />
          </a>
          {/* <div className="text-[#2D8014]">
                        <FaTwitter />
                    </div> */}
          <a
            href="https://www.instagram.com/debonlineshopping/"
            className="text-[#2D8014]"
          >
            <FaInstagram />
          </a>
          <a
            href="https://wa.me/918144570016"
            target="_blank"
            rel="noopener noreferrer"
            className="text-[#2D8014]"
          >
            <FaWhatsapp />
          </a>
        </div>
      </div>
    </nav>
  );
};

export default TopNav;
